import { render, staticRenderFns } from "./ProcessReadOnlyBtmOption.vue?vue&type=template&id=9c994444&scoped=true&"
import script from "./ProcessReadOnlyBtmOption.vue?vue&type=script&lang=js&"
export * from "./ProcessReadOnlyBtmOption.vue?vue&type=script&lang=js&"
import style0 from "./ProcessReadOnlyBtmOption.vue?vue&type=style&index=0&id=9c994444&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c994444",
  null
  
)

export default component.exports